/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { InvalidContext } from "cms/common/errors/invalid-context.error";
import { useContext } from "react";
import { DynamicFieldContext } from "./dynamic-field-context";

export function useDynamicFieldContext () {
    const context = useContext(DynamicFieldContext);

    if (!context) {
        throw new InvalidContext("DynamicFieldContext", "DynamicFieldProvider");
    }

    return context;
}

export function useDynamicFieldPosition () {
    const context = useDynamicFieldContext();
    return context.position;
}
